import antdEN from 'antd/lib/locale-provider/en_GB';

const enGB = {
  messages: {},
  antd: antdEN,
  locale: 'en-GB',
  code: 'en_GB',
};

export default enGB;
